<ng-select [items]="userProfiles" bindLabel="typeName" bindValue="userTypeId" [virtualScroll]="true"
    placeholder="Please Select" [(ngModel)]="userId" (ngModelChange)="userChanged()" [selectOnTab]="true">
</ng-select>
